var _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _path28, _path29, _path30, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 790,
    height: 701.99219,
    viewBox: "0 0 790 701.99219",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.92335,679.03677c-13.32974,39.04189-30.47207,77.99971-52.43309,115.07876-.48744.835-.98036,1.65342-1.47751,2.48541l-54.36844-17.2001c.31277-.787.65529-1.66776,1.02323-2.62911,21.92914-56.71074,154.23254-402.23642,148.294-470.36194C925.60081,311.98621,946.29807,496.53049,883.92335,679.03677Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M841.97922,797.43384c-.73886.75543-1.497,1.50475-2.26061,2.23766l-40.786-12.90312c.55137-.66713,1.19352-1.45315,1.93189-2.34165,12.07938-14.75186,47.99146-58.91856,83.05881-105.39,37.68531-49.9396,74.40225-102.533,79.54812-124.14378C962.43788,559.80726,930.25528,709.40339,841.97922,797.43384Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M862.36664,222.11816c-.01538,0-.0296.0044-.045.00489v-87.4292a35.69,35.69,0,0,0-35.69-35.68994h-273.72a35.69,35.69,0,0,0-35.69,35.68994v44.8208a2.89173,2.89173,0,0,0-2.83008,2.88867v22.2002a2.891,2.891,0,0,0,2.83008,2.88818v23.25684h-.14508a2.89485,2.89485,0,0,0-2.895,2.895v42.92969a2.89486,2.89486,0,0,0,2.895,2.895h.14508v17.05029h-.04511a2.89485,2.89485,0,0,0-2.89495,2.895v43.34961a2.89485,2.89485,0,0,0,2.89495,2.895h.04511V764.68408a35.69,35.69,0,0,0,35.69,35.68994h273.72a35.69,35.69,0,0,0,35.69-35.68994V307.13379c.01538,0,.0296.00439.045.00439a5.15473,5.15473,0,0,0,5.155-5.15478v-74.71A5.15515,5.15515,0,0,0,862.36664,222.11816Z",
    transform: "translate(-205 -99.00391)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M841.01166,144.684v610a27.41,27.41,0,0,1-27.41,27.4h-247.66a27.41,27.41,0,0,1-27.41-27.4v-610a27.41,27.41,0,0,1,27.41-27.41h37.06v4.81a22.58,22.58,0,0,0,22.57,22.57h126a22.57,22.57,0,0,0,22.52-22.57v-4.76h39.51A27.41,27.41,0,0,1,841.01166,144.684Z",
    transform: "translate(-205 -99.00391)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.411,441.28564a10.74274,10.74274,0,0,0-14.42255,7.9585l-88.25427,47.98779,15.51715,17.46436,81.96-52.59912a10.80091,10.80091,0,0,0,5.19971-20.81153Z",
    transform: "translate(-205 -99.00391)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "211.903 687.551 222.9 680.438 200.697 634.635 184.466 645.133 211.903 687.551",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.53251,772.48423h41.16277a0,0,0,0,1,0,0V788.388a0,0,0,0,1,0,0H428.84164a15.30912,15.30912,0,0,1-15.30912-15.30912v-.59467a0,0,0,0,1,0,0Z",
    transform: "translate(1017.48743 1100.95886) rotate(147.10411)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.511 689.206 101.608 689.206 107.841 638.688 88.511 638.688 88.511 689.206",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.7046,784.46734h41.16277a0,0,0,0,1,0,0v15.9038a0,0,0,0,1,0,0H306.01373A15.30912,15.30912,0,0,1,290.7046,785.062v-.59467A0,0,0,0,1,290.7046,784.46734Z",
    transform: "translate(417.57198 1485.83458) rotate(-180)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M594,197.99609H567a2.5,2.5,0,0,1,0-5h27a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-205 -99.00391)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M594,204.99609H567a2.5,2.5,0,0,1,0-5h27a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-205 -99.00391)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M594,211.99609H567a2.5,2.5,0,0,1,0-5h27a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-205 -99.00391)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M803.29156,205.04605h-.91l-.35-.29a7.61019,7.61019,0,0,0,1.78-4.89,7.44,7.44,0,1,0-7.4,7.48,7.73,7.73,0,0,0,4.88-1.78l.34.29v.92l5.74,5.75,1.72-1.72Zm-6.88,0a5.18,5.18,0,1,1,5.15992-5.2l.00006.02a5.15,5.15,0,0,1-5.11994,5.17992c-.0133.00008-.02667.00011-.04.00008Z",
    transform: "translate(-205 -99.00391)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M649.00537,289.99609H600.5a11,11,0,0,1,0-22h48.50537a11,11,0,0,1,0,22Z",
    transform: "translate(-205 -99.00391)",
    fill: "#00bfa6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M797.5,313.99609h-202a6,6,0,0,1,0-12h202a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M669.7002,337.99609H595.5a6,6,0,0,1,0-12h74.2002a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M649.00537,555.99609H600.5a11,11,0,0,1,0-22h48.50537a11,11,0,0,1,0,22Z",
    transform: "translate(-205 -99.00391)",
    fill: "#00bfa6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M797.5,579.99609h-202a6,6,0,0,1,0-12h202a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M669.7002,603.99609H595.5a6,6,0,0,1,0-12h74.2002a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M649.00537,678.99609H600.5a11,11,0,0,1,0-22h48.50537a11,11,0,0,1,0,22Z",
    transform: "translate(-205 -99.00391)",
    fill: "#00bfa6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M797.5,702.99609h-202a6,6,0,0,1,0-12h202a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M669.7002,726.99609H595.5a6,6,0,0,1,0-12h74.2002a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M826,493.49609H440a8.50981,8.50981,0,0,1-8.5-8.5v-105a8.50951,8.50951,0,0,1,8.5-8.5H826a8.50982,8.50982,0,0,1,8.5,8.5v105A8.51013,8.51013,0,0,1,826,493.49609Z",
    transform: "translate(-205 -99.00391)",
    fill: "#00bfa6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M301.23159,618.41614c3.69,25.89-15.85,140.59-13.68,140.57995l28.06-.15c1-1.92,13.88-63.81,17.92-73.74,5.64-13.78,11.33-27.73,13.55-42.45,2.09-13.82,1.06-27.9-.3-41.81a2.64,2.64,0,0,0-3.06-3l-37.65-1.94c-7.76-.4-9.6-2.1-8.42,5.52C298.47158,607.11615,300.41158,612.65613,301.23159,618.41614Z",
    transform: "translate(-205 -99.00391)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.63158,555.46616c-7.65,11-15.67,23.66-13.13,36.83,1.93,10,9.55,17.75,16.74,25,28.74,28.86,85.41,156.2,85.41,156.2,27.3484-17.50006-.6516.49994,27.1-18-2.46-.19-58.35-201.1-62.98-201.37C343.04159,552.88614,326.88158,551.05615,308.63158,555.46616Z",
    transform: "translate(-205 -99.00391)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M338.8901,450.76705c-3.88566-3.46527-31.19235-14.1516-31.19235-14.1516a4.68431,4.68431,0,0,0-1.5087.04526c-1.554.39225-2.26305,2.32338-1.93113,3.88489s-2.39129,27.22447-3.09283,38.89426c-1.22959,20.36744,10.76456,66.50345,10.659,67.91408a21.0765,21.0765,0,0,1-6.20829,13.29164c.93413,1.15954,60.265,3.48511,64.30074,4.858.81469-1.03345-4.594-74.2129-4.84293-78.34672C364.65868,480.88067,344.01966,455.51947,338.8901,450.76705Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M296.57277,609.55457a10.74272,10.74272,0,0,0,3.84156-16.01843l25.033-138.54005-23.36007-.30784-17.384,136.99816a10.80091,10.80091,0,0,0,11.86954,17.86816Z",
    transform: "translate(-205 -99.00391)",
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M296.37159,465.27612a4.43008,4.43008,0,0,1-2.76-.72c-1.39-1.19,9.95-19.4,12.19-19.67,7.29-.84,14.79-1.12,21.86.85s13.72,6.45,16.88,13.08c1.32,2.76-8.25,16.65-12.6,14.61C326.73159,470.98615,303.23159,465.44614,296.37159,465.27612Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.102,
    cy: 309.88012,
    r: 26.2388,
    fill: "#ffb8b8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M296.32988,452.26749A21.92466,21.92466,0,0,0,319.41549,423.542c-1.04421-3.13933-2.78963-6.01687-3.74586-9.1841s-.98231-6.91217,1.13861-9.45136c4.14967-4.968,12.14792-1.84307,18.54524-2.83076,6.81664-1.05242,12.04628-7.59224,12.59177-14.46805s-3.03837-13.68-8.37342-18.05169-12.21571-6.5243-19.08006-7.19875a51.59436,51.59436,0,0,0-52.95464,70.4952c2.86787,7.17557,7.55225,13.85879,14.20586,17.78854s15.44129,4.68471,22.07272.71765",
    transform: "translate(-205 -99.00391)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M577.277,419.49609h-67.0539c-4.25851,0-7.723-4.93457-7.723-11s3.46454-11,7.72305-11H577.277c4.25851,0,7.723,4.93457,7.723,11S581.53546,419.49609,577.277,419.49609Z",
    transform: "translate(-205 -99.00391)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M757.5,443.49609h-249a6,6,0,0,1,0-12h249a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M629.7002,467.49609H508.5a6,6,0,0,1,0-12H629.7002a6,6,0,0,1,0,12Z",
    transform: "translate(-205 -99.00391)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 699.99219,
    width: 790,
    height: 2,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteList);
export default __webpack_public_path__ + "static/media/note-list.115228935b8ae822382284493b261e25.svg";
export { ForwardRef as ReactComponent };